import Icon from "@/elements/Icon/Icon";
import styles from "./FilterTrigger.module.css";

interface FilterTriggerProps {
  value?: string;
  isOpen: boolean;
  onKeyDown: (e: KeyboardEvent) => void;
  ariaLabel: string;
}

function FilterTrigger({
  value,
  isOpen,
  onKeyDown,
  ariaLabel,
}: FilterTriggerProps) {
  const iconName = isOpen ? "#chevron-up" : "#chevron-down";
  return (
    <button
      onKeyDown={onKeyDown}
      aria-expanded={isOpen}
      aria-haspopup="true"
      aria-label={ariaLabel}
      type="button"
    >
      {value && <span>{value}</span>}
      <span className="br-icon br-icon--sm" aria-hidden="true">
        <svg>
          <use href={iconName} />
        </svg>
      </span>
    </button>
  );
}

export default FilterTrigger;
